import React, { useState, useEffect } from 'react';
import { 
    Dialog, DialogTitle, DialogContent, DialogActions, Button, 
    TextField, Box, Typography, CircularProgress, ToggleButton, ToggleButtonGroup
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import SendIcon from '@mui/icons-material/Send';
import EmailIcon from '@mui/icons-material/Email';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { formatDateDisplay } from '../../utils/dateUtils'; 
import * as API from '../../api';

const DIRECTION_LABELS = {
    'ONE_WAY_TO': 'Chiều đi', 'ONE_WAY_FROM': 'Chiều về', 'ROUND_TRIP': 'Hai chiều'
};

const generateTextTemplate = (transports) => {
    if (!transports || transports.length === 0) return '';
    const supplierName = transports[0].supplier_name || 'Nhà xe';
    
    let text = `[Fola Travel Booking] Đặt xe - ${supplierName} - ${transports.length} chuyến\n`;
    text += `Fola Travel xin gửi yêu cầu đặt ${transports.length} chuyến xe như sau:\n`; // XÓA LỜI CHÀO ĐỐI TÁC
    text += `==================================\n`;

    transports.forEach((t, i) => {
        const sDate = t.start_date ? t.start_date.split('-').reverse().join('/') : '---';
        const eDate = t.end_date ? t.end_date.split('-').reverse().join('/') : '---';

        const paxParts = [];
        if (t.adults_count) paxParts.push(`${t.adults_count} NL`);
        if (t.children_count) paxParts.push(`${t.children_count} TE`);
        const paxText = paxParts.length > 0 ? paxParts.join(', ') : '---';

        const dateDisplay = (t.direction === 'ROUND_TRIP' && t.start_date !== t.end_date) 
            ? `Chiều đi: ${sDate} - Chiều về: ${eDate}` 
            : sDate;

        text += `${i + 1}. Khách: ${t.customer_name || 'Khách lẻ'} - SĐT: ${t.customer_phone || ''}\n`;
        text += `   Mã BK: ${t.booking_code}\n`;
        text += `   Số lượng: ${paxText}\n`;
        text += `   Ngày đi: ${dateDisplay}\n`;
        text += `   Loại xe: ${t.vehicle_type_display || t.vehicle_type} (${DIRECTION_LABELS[t.direction] || t.direction})\n`;
        text += `   Điểm đón: ${t.pickup_point || 'Chưa rõ'}\n`;
        text += `   Điểm trả: ${t.dropoff_point || 'Chưa rõ'}\n`;
        text += `   Ghi chú: ${t.note || ''}\n`; 
        text += `----------------------------------\n`;
    });

    text += `\nĐại lý: Fola Travel - 0363463666 hoặc 0986332366 (Mr. Hùng).\nQuý công ty vui lòng xác nhận đặt chỗ tại đây.\nTrân trọng,`;
    return text;
};

const generateHtmlTemplate = (transports) => {
    if (!transports || transports.length === 0) return '';
    const supplierName = transports[0].supplier_name || 'Nhà xe';
    
    const tableStyle = `width: 100%; border-collapse: collapse; font-family: Arial, sans-serif; font-size: 13px;`;
    const thStyle = `border: 1px solid #333; padding: 5px; background-color: #f2f2f2; text-align: center; font-weight: bold;`;
    const tdStyle = `border: 1px solid #333; padding: 5px; vertical-align: top;`;

    const rows = transports.map(t => {
        const paxParts = [];
        if (t.adults_count) paxParts.push(`${t.adults_count} NL`);
        if (t.children_count) paxParts.push(`${t.children_count} TE`);
        const paxInfo = paxParts.length > 0 ? paxParts.join(', ') : '---';

        const sDate = t.start_date ? t.start_date.split('-').reverse().join('/') : '---';
        const eDate = t.end_date ? t.end_date.split('-').reverse().join('/') : '---';

        const dateDisplay = (t.direction === 'ROUND_TRIP' && t.start_date !== t.end_date)
            ? `<b>Chiều đi:</b> ${sDate} <br/> <b>Chiều về:</b> ${eDate}`
        : sDate;

        return `
        <tr>
            <td style="${tdStyle}; text-align: center;">${t.booking_code}</td>
            <td style="${tdStyle}">${t.customer_name || 'Khách lẻ'} <br/> ${t.customer_phone || ''}</td>
            <td style="${tdStyle}; text-align: center;">${paxInfo}</td>
            <td style="${tdStyle}; text-align: center; font-weight: bold; color: #ed6c02;">${dateDisplay}</td> <td style="${tdStyle}">${t.vehicle_type_display || t.vehicle_type}<br/><b>${DIRECTION_LABELS[t.direction] || t.direction}</b></td>
            <td style="${tdStyle}"><b>Đón:</b> ${t.pickup_point || '---'}<br/><b>Trả:</b> ${t.dropoff_point || '---'}</td>
            <td style="${tdStyle}">${t.note || ''}</td> </tr>`;
    }).join('');

    return `<html>
<body style="font-family: Arial, sans-serif; line-height: 1.6;">
    <div style="margin-bottom: 10px;">Fola Travel xin gửi yêu cầu đặt ${transports.length} chuyến xe như sau:</div> <table style="${tableStyle}">
        <thead>
            <tr>
                <th style="${thStyle}">Mã BK</th>
                <th style="${thStyle}">Khách hàng</th>
                <th style="${thStyle}">Số lượng</th> 
                <th style="${thStyle}">Ngày đi</th> <th style="${thStyle}">Loại xe & Chiều</th>
                <th style="${thStyle}">Điểm Đón/Trả</th>
                <th style="${thStyle}">Ghi chú</th>
            </tr>
        </thead>
        <tbody>${rows}</tbody>
    </table>
    <div style="margin-top: 15px;"><strong>Đại lý: Fola Travel</strong></div>
    <div>--------------------------------------------------</div>
    <div style="margin-top: 10px;">Mọi thông tin chi tiết vui lòng liên hệ số hotline Fola Travel tại 0363463666 hoặc 0986332366 (Mr. Hùng).</div>
    <div>Quý công ty vui lòng xác nhận đặt chỗ qua email này.</div>
    <div style="margin-top: 10px;">Trân trọng,</div>
</body></html>`;
};

const TransportOrderDialog = ({ open, onClose, selectedTransports, showToast, onSuccess }) => {
    const [textContent, setTextContent] = useState('');
    const [htmlContent, setHtmlContent] = useState('');
    const [recipientEmail, setRecipientEmail] = useState('');
    const [ccEmail, setCcEmail] = useState('');
    const [emailSubject, setEmailSubject] = useState('');
    const [viewMode, setViewMode] = useState('EMAIL');
    const [sending, setSending] = useState(false);

    useEffect(() => {
    if (open && selectedTransports.length > 0) {
        setTextContent(generateTextTemplate(selectedTransports));
        setHtmlContent(generateHtmlTemplate(selectedTransports));
        
        const firstT = selectedTransports[0];
        setRecipientEmail(firstT.supplier_email || firstT.supplier?.email || '');
        setCcEmail(firstT.supplier_cc_emails || firstT.supplier?.cc_emails || '');
        
        const routeName = firstT.route_details?.route_name || firstT.route || '---';
        const dateStr = firstT.start_date ? firstT.start_date.split('-').reverse().join('/') : '---';
        const subject = `[Fola Travel Booking] - Đặt xe ${routeName} - Ngày ${dateStr} - ${selectedTransports.length} BK`;
        setEmailSubject(subject);

        setViewMode('EMAIL');
    }
}, [open, selectedTransports]);

    const handleCopy = () => {
        navigator.clipboard.writeText(textContent);
        if (showToast) showToast('Đã copy nội dung Text!', 'success');
    };

    const handleSendEmail = async () => {
        if (!recipientEmail) {
            if (showToast) showToast('Vui lòng nhập Email Nhà xe!', 'error');
            return;
        }

        setSending(true);
        try {
            await API.client.post('/transports/send_transport_order_email/', {
                email: recipientEmail,
                cc: ccEmail,
                subject: emailSubject,
                content: htmlContent 
            });
            
            // Update trạng thái sang CONTACTED
            const updatePromises = selectedTransports.map(t => 
                API.client.patch(`/transports/${t.id}/update_status/`, { operation_status: 'CONTACTED' })
            );
            await Promise.all(updatePromises);

            if (showToast) showToast(`Đã gửi email đặt xe thành công!`, 'success');
            if (onSuccess) onSuccess(); 
            onClose();
        } catch (error) {
            if (showToast) showToast('Lỗi gửi mail đặt xe.', 'error');
        } finally {
            setSending(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle sx={{ bgcolor: '#ed6c02', color: 'white' }}>
                <Typography variant="h6">LỆNH ĐẶT XE ({selectedTransports.length} chuyến)</Typography>
            </DialogTitle>
            <DialogContent dividers>
                <Box sx={{ display: 'flex', gap: 2, height: '480px' }}>
                    {/* Cột trái: DS Xe */}
                    <Box sx={{ width: '25%', borderRight: '1px solid #eee', pr: 2, overflowY: 'auto' }}>
                        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>Danh sách Xe:</Typography>
                        {selectedTransports.map((t, i) => (
                            <Box key={t.id} sx={{ p: 1, mb: 1, bgcolor: '#f5f5f5', borderRadius: 1, border: '1px solid #ddd' }}>
                                <Typography variant="caption" fontWeight="bold" sx={{ color: '#ed6c02' }}>
                                    #{i + 1} - BK: {t.booking_code}
                                </Typography>
                                <Typography variant="caption" display="block">Khách: {t.customer_name}</Typography>
                                <Typography variant="caption" display="block">Chiều: {DIRECTION_LABELS[t.direction]}</Typography>
                            </Box>
                        ))}
                    </Box>
                    {/* Cột phải: Editor */}
                    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <Box>
                            <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#555' }}>Tiêu đề:</Typography>
                            <TextField fullWidth size="small" value={emailSubject} onChange={(e) => setEmailSubject(e.target.value)} placeholder="Tiêu đề..." />
                        </Box>
                        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#555' }}>
                                    {viewMode === 'EMAIL' ? 'Nội dung Email:' : 'Nội dung Text:'}
                                </Typography>
                                <ToggleButtonGroup value={viewMode} exclusive onChange={(e, v) => v && setViewMode(v)} size="small" sx={{ bgcolor: '#f5f5f5', height: '32px' }}>
                                    <ToggleButton value="EMAIL" sx={{ px: 2, fontSize: '0.75rem', fontWeight: 'bold', textTransform: 'none' }}><EmailIcon sx={{ mr: 1, fontSize: '1rem' }} /> Email (Bảng)</ToggleButton>
                                    <ToggleButton value="TEXT" sx={{ px: 2, fontSize: '0.75rem', fontWeight: 'bold', textTransform: 'none' }}><TextSnippetIcon sx={{ mr: 1, fontSize: '1rem' }} /> Text (Copy)</ToggleButton>
                                </ToggleButtonGroup>
                            </Box>
                            {viewMode === 'EMAIL' ? (
                                <TextField multiline fullWidth value={htmlContent} onChange={(e) => setHtmlContent(e.target.value)} sx={{ flex: 1, bgcolor: '#fff3e0', '& .MuiInputBase-root': { height: '100%', alignItems: 'flex-start', fontFamily: 'monospace', fontSize: '0.85rem' } }} />
                            ) : (
                                <TextField multiline fullWidth value={textContent} onChange={(e) => setTextContent(e.target.value)} sx={{ flex: 1, bgcolor: '#f9fbe7', '& .MuiInputBase-root': { height: '100%', alignItems: 'flex-start', fontFamily: 'monospace', fontSize: '0.9rem' } }} />
                            )}
                        </Box>
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions sx={{ p: 2, justifyContent: 'space-between', bgcolor: '#f9f9f9' }}>
                <Box sx={{ flex: 1, mr: 2 }}>
                    {viewMode === 'EMAIL' && (
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <TextField fullWidth size="small" label="Gửi tới (Email Nhà xe)" value={recipientEmail} onChange={(e) => setRecipientEmail(e.target.value)} bgcolor="white" />
                            <TextField fullWidth size="small" label="CC Email" value={ccEmail} onChange={(e) => setCcEmail(e.target.value)} bgcolor="white" />
                        </Box>
                    )}
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button onClick={onClose} color="inherit">Đóng</Button>
                    {viewMode === 'TEXT' && <Button variant="contained" color="success" onClick={handleCopy}>Copy Text</Button>}
                    {viewMode === 'EMAIL' && <Button variant="contained" onClick={handleSendEmail} disabled={sending || !recipientEmail} sx={{ bgcolor: '#ed6c02', '&:hover': {bgcolor: '#e65100'} }}>{sending ? 'Đang gửi...' : 'Gửi Email'}</Button>}
                </Box>
            </DialogActions>
        </Dialog>
    );
};

export default TransportOrderDialog;